import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-back",
  "use": "menu-back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"menu-back\"><path d=\"M22.184 37.597h0L9.208 24.607l12.977-12.99M9.21 24.608h29.999\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"#000\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol